import { Eye, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useImpersonation } from "@/contexts/ImpersonationContext";

const roleLabels: Record<string, string> = {
  superadmin: "Super Admin",
  principal: "Principal",
  deputy_principal: "Deputy Principal",
  head_admission: "Head of Admission",
  head_administration: "Head of Administration",
  head_academic: "Head of Academic",
  head_examination: "Head of Examination",
  head_accounting: "Head of Accounting",
  head_student_service: "Head of Student Services",
  head_discipline: "Head of Discipline",
  hod_cmt: "HoD CMT",
  hod_pst: "HoD PST",
  hod_sw: "HoD SW",
  it_incharge: "IT Incharge",
  security_man: "Security Man",
  cr_cmt4: "CR CMT4",
  cr_cmt5: "CR CMT5",
  cr_cmt6: "CR CMT6",
  cr_pst4: "CR PST4",
  cr_pst5: "CR PST5",
  cr_pst6: "CR PST6",
  cr_sw4: "CR SW4",
  cr_sw5: "CR SW5",
  cr_sw6: "CR SW6",
  auditor: "Auditor",
  student: "Student",
};

export function ImpersonationBar() {
  const { active, mode, previewRoles, targetUser, simulatedStudent, stop } = useImpersonation();

  if (!active) return null;

  let label = "";
  if (mode === "student_simulation" && simulatedStudent) {
    label = `Simulating: ${simulatedStudent.fullName} (Form IV: ${simulatedStudent.formIvIndex})${simulatedStudent.source === "pre_registration" ? " [Pre-registered]" : ""}`;
  } else if (mode === "role_preview") {
    label = `Previewing as: ${previewRoles?.map((r) => roleLabels[r] || r).join(", ")}`;
  } else {
    label = `Impersonating: ${targetUser?.fullName} (${targetUser?.roles.map((r) => roleLabels[r] || r).join(", ")})`;
  }

  return (
    <div className="h-10 flex items-center justify-between bg-amber-500 text-amber-950 px-4 text-sm font-medium shrink-0">
      <div className="flex items-center gap-2">
        <Eye className="h-4 w-4" />
        <span>{label}</span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        className="h-7 text-amber-950 hover:bg-amber-600 hover:text-amber-950"
        onClick={stop}
      >
        <X className="h-4 w-4 mr-1" />
        Exit
      </Button>
    </div>
  );
}
